(function($) {
  var Module = {
    init: function() {
      this.filter = $( '[data-component="filter-events"]' );
      this.list = $( '[data-element="events-list"]' );
      this.endpoint = window.location.origin + '/wp-json/wp/v2/eventos/';
      this.query = {};
      this.ajax = null;
      this._lockedAjax = false;

      this.setPagination();
      this.addEventListener();
    },

    setPagination: function() {
      this.pagination = $( '[data-component="events-pagination"]' );
      this.max = this.pagination.data( 'total-pages' );
      this.button = this.pagination.find( '.btn-s-text' );
      this.paged = 1;
    },

    addEventListener: function() {
      this.filter.on( 'change', '[data-action="state"]', this._onChangeState.bind( this ) );
      this.filter.on( 'change', '[data-action="year"]', this._onChangeYear.bind( this ) );
      this.filter.on( 'change', '[data-action="month"]', this._onChangeMonth.bind( this ) );
      this.pagination.on( 'click', '[data-action="next-page"]', this._onClickPaginate.bind( this ) );
    },

    getQueryString: function() {
      var qs = {};

      $.each( this.query, function(index, value) {
        value && ( qs[index] = value );
      } );

      return $.param( qs );
    },

    _onChangeState: function(e) {
      var value = $( e.currentTarget ).val() || [];

      $.extend( this.query, {
        state: value.join( ',' )
      } );

      this.setParams();
      this.request();
    },

    _onChangeYear: function(e) {
      var value = $( e.currentTarget ).val() || [];

      $.extend( this.query, {
        year: value
      } );

      this.setParams();
      this.request();
    },

    _onChangeMonth: function(e) {
      var value = $( e.currentTarget ).val() || [];

      $.extend( this.query, {
        month: value
      } );

      this.setParams();
      this.request();
    },

    _onClickPaginate: function(e) {
      this.getNextPage();
    },

    getNextPage: function() {
      this.paged += 1;
      this.request();
    },

    setParams: function() {
      this.paged = 1;
      this.endpoint = window.SiteGlobalVars.restUrl + 'eventos/?' + this.getQueryString();
    },

    request: function() {
      if (this._lockedAjax) {
        return;
      }

      var params = {
        page: this.paged
      };

      this.ajax = $.ajax( {
        url: this.endpoint,
        data: params,
        success: this._done.bind( this ),
        error: this._fail.bind( this )
      } );

      this.setStateWait();
    },

    _done: function(data) {
      this.render( data );
      this.setStateNormal();

      if ( this.isRequestNewPage() ) {
        this.pagination.show();
      } else {
        this.pagination.hide();
      }
    },

    _fail: function() {
      this.setStateNormal();
    },

    render: function(data) {
      var elements = $( MONKEY.Templates.eventItem( data ) );

      if (this.paged == 1) {
        this.list.html( elements );
      } else {
        this.list.append( elements );
      }
    },

    setStateWait: function() {
      this._lockedAjax = true;
      this.button.text( 'AGUARDE...' );
    },

    setStateNormal: function() {
      this._lockedAjax = false;
      this.button.text( 'CARREGAR MAIS' );
    },

    isRequestNewPage: function() {
      return ( this.paged <= ( this.getMax() - 1 ) );
    },

    getMax: function() {
      return this.ajax.getResponseHeader( 'X-WP-TotalPages' ) || this.max;
    }
  };

  Module.init();
})(jQuery);
